import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  EVENT_TICKET_PURCHASES_FEATURE_KEY,
  eventTicketPurchasesAdapter,
  EventTicketPurchasesState,
} from './event-ticket-purchases.reducer'

// Lookup the 'EventTicketPurchases' feature state managed by NgRx
export const selectEventTicketPurchasesState = createFeatureSelector<EventTicketPurchasesState>(
  EVENT_TICKET_PURCHASES_FEATURE_KEY,
)

export const { selectAll, selectEntities } = eventTicketPurchasesAdapter.getSelectors()

export const selectEventTicketPurchasesEntities = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => selectEntities(state),
)

export const selectCurrentAmount = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.amount || 0,
)

export const selectSelectedId = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.selectedId,
)

export const selectedEventTicketPurchase = createSelector(
  selectEventTicketPurchasesEntities,
  selectSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
)

/**
 * Get event tickets for the selected purchase ID
 */
export const selectedPurchaseEventTickets = createSelector(
  selectedEventTicketPurchase,
  (eventTicketPurchase) => eventTicketPurchase?.tickets || [],
)

/**
 * Get event ticket custom fields for the selected purchase ID
 */
export const selectedPurchaseCustomFields = createSelector(selectedPurchaseEventTickets, (eventTickets) =>
  eventTickets.length ? eventTickets[0].ticket_package.custom_fields : [],
)
